import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b9c43cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "EmailRegistration" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "RegisterWithSocial" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Or register with", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegistrationHeader = _resolveComponent("RegistrationHeader")!
  const _component_NameInput = _resolveComponent("NameInput")!
  const _component_EmailInput = _resolveComponent("EmailInput")!
  const _component_PasswordInput = _resolveComponent("PasswordInput")!
  const _component_Captcha = _resolveComponent("Captcha")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!
  const _component_SocialIncentiveButtons = _resolveComponent("SocialIncentiveButtons")!
  const _component_PrivacyStatement = _resolveComponent("PrivacyStatement")!
  const _component_RedirectToLogin = _resolveComponent("RedirectToLogin")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_RegistrationHeader),
    _createElementVNode("form", {
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)), ["prevent"])),
      class: "FgForm"
    }, [
      _createVNode(_component_NameInput),
      _createVNode(_component_EmailInput),
      _createVNode(_component_PasswordInput, {
        validation: "",
        autocompletePasswordType: "new-password"
      }),
      _createVNode(_component_Captcha),
      _createVNode(_component_SubmitButton, {
        type: "register",
        onSubmitButtonClicked: _ctx.register
      }, null, 8 /* PROPS */, ["onSubmitButtonClicked"]),
      (_ctx.store.getters.errorMessage().message)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.store.getters.errorMessage().message), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ], 32 /* HYDRATE_EVENTS */),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_SocialIncentiveButtons, { direction: "row" })
    ]),
    _createVNode(_component_PrivacyStatement),
    _createVNode(_component_RedirectToLogin)
  ]))
}